import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useAddToWishlist = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const save = async (bookId) => {
		const instance = await InitApi({ accessToken });
		const response = await instance.post(`books/${bookId}/wishlist`);
		await queryClient.invalidateQueries(["wishlist"]);
		await queryClient.invalidateQueries(["profile"]);
		await queryClient.invalidateQueries(["books", bookId]);
		await queryClient.invalidateQueries(["books"]);
		return response;
	};

	return useMutation(save, {
		onSuccess: async ({ data: body }) => {
			toast.success(body?.message || "Added to wishlist");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);
			if (error?.response?.data?.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useAddToWishlist;
